// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '7e9c138c-240e-42d4-b486-abedb2e0632a',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'a6d657b5-d654-41a5-b39b-be0dde85ca4f',
      type: 'Container',
      name: 'image1',
      className: '',
      x: -234,
      y: 169,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7e9c138c-240e-42d4-b486-abedb2e0632a'
    },
    {
      id: '0a95f885-3886-442a-914e-2f0b0006110c',
      type: 'Container',
      name: 'image2',
      className: '',
      x: 217,
      y: 306,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7e9c138c-240e-42d4-b486-abedb2e0632a'
    },
    {
      id: 'fe22893d-8bd8-4672-88f6-b146a17e3615',
      type: 'Container',
      name: 'image3',
      className: '',
      x: -199,
      y: 564,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7e9c138c-240e-42d4-b486-abedb2e0632a'
    },
    {
      id: 'd26a8172-cfc9-4b73-865c-f9431c587608',
      type: 'Sprite',
      name: 'arrow1',
      className: '',
      x: -125,
      y: 264,
      anchor: {
        x: 0,
        y: 0.245
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Explanation_Arrow',
      parent: '7e9c138c-240e-42d4-b486-abedb2e0632a'
    },
    {
      id: 'dc4ab20e-25d5-4f71-8f60-beffeafbe189',
      type: 'Sprite',
      name: 'arrow2',
      className: '',
      x: 88,
      y: 385,
      anchor: {
        x: 0,
        y: 0.25
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1.3,
        y: 1.3
      },
      angle: -13.5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Explanation_Arrow',
      parent: '7e9c138c-240e-42d4-b486-abedb2e0632a'
    },
    {
      id: '28fa545f-9fb3-42a1-9eef-760a557ba961',
      type: 'Container',
      name: 'premiumContainer',
      className: 'centerChildren_SPL',
      x: 0,
      y: 862,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7e9c138c-240e-42d4-b486-abedb2e0632a',
      data: {
        centerChildrenPadding: 20
      }
    },
    {
      id: 'a04b2132-9c92-434d-9a5b-09f12ba90ec0',
      type: 'Container',
      name: 'buttonScaleWrapper',
      className: '',
      x: 0,
      y: 975,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7e9c138c-240e-42d4-b486-abedb2e0632a'
    },
    {
      id: '750f38f3-fcb1-4b72-8fc5-94e633d02f81',
      type: 'Sprite',
      name: '',
      className: '',
      x: 28,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Explanation_Image_Season_Pass_1',
      parent: 'a6d657b5-d654-41a5-b39b-be0dde85ca4f'
    },
    {
      id: 'f1d62d2d-fb24-4358-9bf7-cd5cc662142d',
      type: 'Text',
      name: '',
      className: '',
      x: 28,
      y: 168,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Beat Levels',
      localize: true,
      maxWidth: 381,
      maxHeight: 130,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 302,
        breakWords: false,
        lineHeight: 32,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'a6d657b5-d654-41a5-b39b-be0dde85ca4f'
    },
    {
      id: '52bf5eac-48b8-4cfe-8174-5a9a2c0b160e',
      type: 'Sprite',
      name: '',
      className: '',
      x: -25,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Explanation_Image_Season_Pass_2',
      parent: '0a95f885-3886-442a-914e-2f0b0006110c'
    },
    {
      id: '5a14d7db-9af9-481c-b548-f49a3c61061d',
      type: 'Text',
      name: '',
      className: '',
      x: -25,
      y: 188,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Collect Keys',
      localize: true,
      maxWidth: 382,
      maxHeight: 246,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 248,
        breakWords: false,
        lineHeight: 32,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0a95f885-3886-442a-914e-2f0b0006110c'
    },
    {
      id: '17b1a6bd-92db-42dc-b272-0103f7b7c82b',
      type: 'Sprite',
      name: '',
      className: '',
      x: 29,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Explanation_Image_Season_Pass_3',
      parent: 'fe22893d-8bd8-4672-88f6-b146a17e3615'
    },
    {
      id: 'cbbad815-7b54-4a21-a368-4fd557eb4a97',
      type: 'Text',
      name: '',
      className: '',
      x: 29,
      y: 159,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Claim Rewards!',
      localize: true,
      maxWidth: 499,
      maxHeight: 79,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 32,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fe22893d-8bd8-4672-88f6-b146a17e3615'
    },
    {
      id: 'aab1060f-6030-4e1c-bca3-4be32d6db832',
      type: 'Container',
      name: 'premiumTicket',
      className: '',
      x: -284,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '28fa545f-9fb3-42a1-9eef-760a557ba961'
    },
    {
      id: 'd4e1687d-5b21-46d3-89ae-f4b5c0ca7ddc',
      type: 'Text',
      name: '',
      className: 'colorTags_SPL',
      x: 123,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Get the $Premium Pass$<br>to get even MORE rewards!',
      localize: true,
      maxWidth: 570,
      maxHeight: 129,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 570,
        breakWords: false,
        lineHeight: 28,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '28fa545f-9fb3-42a1-9eef-760a557ba961',
      data: {
        colorTags: {
          $: '#FDDD3A'
        }
      }
    },
    {
      id: 'aa95d959-fadc-4613-8838-85e2aa1ec0ec',
      type: 'Text',
      name: 'closeButton',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -4000,
        y: -4000,
        width: 8000,
        height: 8000
      },
      text: 'Tap to Continue',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'a04b2132-9c92-434d-9a5b-09f12ba90ec0'
    },
    {
      id: '30dc3786-b8b7-4a96-aff6-5d83840c1171',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Premium_Ticket',
      parent: 'aab1060f-6030-4e1c-bca3-4be32d6db832'
    },
    {
      id: 'e94ce920-6687-4c86-82f9-7b239835053d',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Premium',
      localize: true,
      maxWidth: 177,
      maxHeight: 64,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#7D2726',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 2,
        dropShadowColor: '#FFFA77',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'aab1060f-6030-4e1c-bca3-4be32d6db832'
    },
    {
      id: '0e1097a3-5540-4c13-8d82-865b97b47495',
      type: 'Sprite',
      name: 'premiumTicketOverlay',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Premium_Ticket',
      parent: 'aab1060f-6030-4e1c-bca3-4be32d6db832'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 1026,
  version: '3.1.0',
  animations: [
    {
      id: 'ac0a592a-db40-4474-8b73-3dd2f573273b',
      name: 'Appear',
      playingSpeed: 1,
      totalDuration: 800,
      blocks: [
        {
          id: '99bf16b5-2b02-497e-8b7a-b12ada747ace',
          type: 'Setter',
          name: 'image1setter',
          track: 9,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'image1',
          disabled: false
        },
        {
          id: 'fcec8730-34c3-4edc-b8fc-96661e83ba73',
          type: 'Setter',
          name: 'image2setter',
          track: 6,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'image2',
          disabled: false
        },
        {
          id: 'c23eca98-f28d-4870-ac2a-1efaeee49561',
          type: 'Setter',
          name: 'image3setter',
          track: 5,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'image3',
          disabled: false
        },
        {
          id: 'c240dc57-b664-4863-a810-8d22bfde504b',
          type: 'Setter',
          name: 'arrow1setter',
          track: 4,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'arrow1',
          disabled: false
        },
        {
          id: 'a66a6f98-7f79-49c9-9a7e-c21544171b8d',
          type: 'Setter',
          name: 'arrow2setter',
          track: 3,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'arrow2',
          disabled: false
        },
        {
          id: 'f547a23b-fb2f-4494-be34-8d6a6c6c254d',
          type: 'Setter',
          name: 'buttonSetter',
          track: 2,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'closeButton',
          disabled: false
        },
        {
          id: '0b88d344-f4ce-4715-b31d-1bcf816a4ee8',
          type: 'Setter',
          name: 'premiumSetter',
          track: 1,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'premiumContainer',
          disabled: false
        },
        {
          id: '08ee40bb-d9c6-48b2-9811-ed60f3a5ec98',
          type: 'Tween',
          name: 'image1tween',
          duration: 200,
          track: 11,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 0,
          sourceName: 'image1',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '125d75e0-8cfe-43d7-b0a1-608f8bf43876',
          type: 'Tween',
          name: 'image2tween',
          duration: 200,
          track: 10,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 129,
          sourceName: 'image2',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '9dae45d3-9c0b-41e3-96e3-389f4c5f9cd4',
          type: 'Tween',
          name: 'arrow1tween',
          duration: 400,
          track: 6,
          target: {
            scale: {
              x: 1.3,
              y: 1.3
            }
          },
          startAt: 201,
          sourceName: 'arrow1',
          easing: 'ElasticOut',
          disabled: false
        },
        {
          id: '4171530e-0870-4756-a9ef-eb9540abeeee',
          type: 'Tween',
          name: 'image3tween',
          duration: 200,
          track: 9,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 278,
          sourceName: 'image3',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: 'd3ba0af7-2247-4614-8a94-81618bb60a8c',
          type: 'Tween',
          name: 'arrow2tween',
          duration: 400,
          track: 5,
          target: {
            scale: {
              x: -1.3,
              y: 1.3
            }
          },
          startAt: 343,
          sourceName: 'arrow2',
          easing: 'ElasticOut',
          disabled: false
        },
        {
          id: '3c9551f2-c3d5-4f46-bd1d-c598af419a00',
          type: 'Tween',
          name: 'buttonTween_copy',
          duration: 250,
          track: 7,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 403,
          sourceName: 'premiumContainer',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: 'c7c1870d-4d22-42f1-b434-81a494f70edf',
          type: 'Tween',
          name: 'buttonTween',
          duration: 250,
          track: 8,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 528,
          sourceName: 'closeButton',
          easing: 'CubicOut',
          disabled: false
        }
      ]
    },
    {
      id: 'a8cc0e2d-f40c-49de-a5fb-5cd8cd9f75ee',
      name: 'Idle',
      playingSpeed: 1,
      totalDuration: 1200,
      blocks: [
        {
          id: '3c2ee723-a948-456e-b339-ec785d95b27d',
          type: 'Tween',
          name: 'New_tween',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 0,
          sourceName: 'buttonScaleWrapper',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '2c28fd08-5a82-4523-b672-4a65a3e05690',
          type: 'Tween',
          name: 'New_tween_copy',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 200,
          sourceName: 'buttonScaleWrapper',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '5cf2de2c-fb67-41b7-9472-4e48d70d023b',
          type: 'Tween',
          name: 'New_tween_copy_1',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 400,
          sourceName: 'buttonScaleWrapper',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: 'c62d0d04-ecac-4d47-b340-1c3a0694da6c',
          type: 'Tween',
          name: 'New_tween_copy_copy',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 600,
          sourceName: 'buttonScaleWrapper',
          easing: 'SinusoidalIn',
          disabled: false
        }
      ]
    },
    {
      id: 'ccb8447c-fd90-4ed7-948c-5027025e2789',
      name: 'Idle_PremiumTicket',
      playingSpeed: 1,
      totalDuration: 1600,
      blocks: [
        {
          id: '6d221f01-85f4-424f-9cff-ebf835905dc1',
          type: 'Tween',
          name: 'New_tween_1_copy',
          duration: 800,
          track: 1,
          target: {
            alpha: 0.2
          },
          startAt: 0,
          sourceName: 'premiumTicketOverlay',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '813fa6b3-f619-429e-91bb-703c8e402e77',
          type: 'Tween',
          name: 'New_tween_1',
          duration: 800,
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 800,
          sourceName: 'premiumTicketOverlay',
          easing: 'SinusoidalIn',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class SeasonPassTutorialLayout {
  static raw = raw;
  root!: Container;
  image1!: Container;
  image2!: Container;
  image3!: Container;
  arrow1!: Sprite;
  arrow2!: Sprite;
  premiumContainer!: Container & { data: typeof raw['list'][6]['data'] };
  buttonScaleWrapper!: Container;
  premiumTicket!: Container;
  closeButton!: Text;
  premiumTicketOverlay!: Sprite;
  centerChildren_SPL!: (Container & { data: typeof raw['list'][6]['data'] })[];
  colorTags_SPL!: (Text & { data: typeof raw['list'][15]['data'] })[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Appear {
  Layout: {
    image1: object;
    image2: object;
    image3: object;
    arrow1: object;
    arrow2: object;
    closeButton: object;
    premiumContainer: object;
  };

  BlockTypeByName: {
    image1setter: object;
    image2setter: object;
    image3setter: object;
    arrow1setter: object;
    arrow2setter: object;
    buttonSetter: object;
    premiumSetter: object;
    image1tween: object;
    image2tween: object;
    arrow1tween: object;
    image3tween: object;
    arrow2tween: object;
    buttonTween_copy: object;
    buttonTween: object;
  };

  flowData = raw.animations[0];
}

export abstract class Idle {
  Layout: {
    buttonScaleWrapper: object;
  };

  BlockTypeByName: {
    New_tween: object;
    New_tween_copy: object;
    New_tween_copy_1: object;
    New_tween_copy_copy: object;
  };

  flowData = raw.animations[1];
}

export abstract class Idle_PremiumTicket {
  Layout: {
    premiumTicketOverlay: object;
  };

  BlockTypeByName: {
    New_tween_1_copy: object;
    New_tween_1: object;
  };

  flowData = raw.animations[2];
}
